import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { EventEmitter, ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinChangeEvent, mixinFocusEvent, mixinBlurEvent, mixinFormControl, FadvBaseComponent, createFormControlProvider, Forward, formControlValueInput, formControlDisabledInput, formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/radio-group/radio-group';
import { FadvRadioModule, FadvRadioComponent } from '@fa-switch-sharedservices/ng-elements/fadv-radio';
import { FadvRadioButtonModule, FadvRadioButtonComponent } from '@fa-switch-sharedservices/ng-elements/fadv-radio-button';
import { FadvRadioCardModule, FadvRadioCardComponent, FadvRadioCardIconDirective } from '@fa-switch-sharedservices/ng-elements/fadv-radio-card';

class Radio {
    constructor() {
        this.blurred = new EventEmitter();
        this.changed = new EventEmitter();
        this.focused = new EventEmitter();
    }
}
class FadvRadioGroupComponent extends mixinChangeEvent(mixinFocusEvent(mixinBlurEvent(mixinFormControl(FadvBaseComponent)))) {
    constructor(base) {
        super(base);
        this.registerSubscription(this.onInit, () => {
            if (this.value) {
                this._setRadioValue(this.value);
            }
        });
        this.registerSubscription(this.afterContentInit, () => {
            this.registerSubscription(this.changed, this._handleChange.bind(this));
            this.registerSubscription(this.blurred, () => this.onTouched());
            this.registerFormValueChangeHandler((value) => this._handleExternalValueChange(value));
        });
    }
    _handleChange(event) {
        const target = event.target;
        if (target && target.checked && target.value) {
            this.reportChange(target.value);
        }
    }
    _handleExternalValueChange(value) {
        this._setRadioValue(value);
    }
    _setRadioValue(value) {
        if (!this.elementRef)
            return;
        if (!this.elementRef.nativeElement)
            return;
        for (const child of this.elementRef.nativeElement.children) {
            child.checked = child.value === value;
        }
    }
}
FadvRadioGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRadioGroupComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvRadioGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvRadioGroupComponent, selector: "fadv-radio-group", inputs: { value: "value", disabled: "disabled", label: "label", fieldset: "fieldset" }, outputs: { valueChange: "valueChange", focused: "focused", blurred: "blurred", changed: "changed" }, providers: [createFormControlProvider(FadvRadioGroupComponent)], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvRadioGroupComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvRadioGroupComponent.prototype, "fieldset", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRadioGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-radio-group',
                    template: '<ng-content></ng-content>',
                    providers: [createFormControlProvider(FadvRadioGroupComponent)],
                    inputs: [formControlValueInput, formControlDisabledInput],
                    outputs: [formControlValueOutput, focusEventOutput, blurEventOutput, changeEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { label: [{
                type: Input
            }], fieldset: [{
                type: Input
            }] } });

class FadvRadioGroupModule {
}
FadvRadioGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRadioGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvRadioGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvRadioGroupModule, declarations: [FadvRadioGroupComponent], imports: [FadvCommonModule, FadvRadioModule, FadvRadioCardModule, FadvRadioButtonModule], exports: [FadvRadioGroupComponent, FadvRadioCardComponent, FadvRadioCardIconDirective, FadvRadioComponent, FadvRadioButtonComponent] });
FadvRadioGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRadioGroupModule, imports: [FadvCommonModule, FadvRadioModule, FadvRadioCardModule, FadvRadioButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvRadioGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvRadioGroupComponent],
                    imports: [FadvCommonModule, FadvRadioModule, FadvRadioCardModule, FadvRadioButtonModule],
                    exports: [FadvRadioGroupComponent, FadvRadioCardComponent, FadvRadioCardIconDirective, FadvRadioComponent, FadvRadioButtonComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvRadioGroupComponent, FadvRadioGroupModule, Radio };
